import * as React from 'react';
import Card from '@mui/material/Card';
import { styled } from '@mui/material';

const StyledCard = styled((props) => <Card {...props} />)(({
  selected,
  disabled,
  error,
  variant = 'default', // 'default', 'primary'
}) => ({
  borderRadius: '8px',
  border: '2px solid var(--trashie-ui-crisp-white)',
  background: 'var(--trashie-ui-crisp-white)',
  boxShadow: '0px 4px 15px 0px rgba(0, 0, 0, 0.09)',
  cursor: 'pointer',
  '&:hover': {
    border: '2px solid var(--trashie-ui-faded-black-40)',
    boxShadow: '0px 4px 15px 0px #00000017',
  },
  ...(selected && {
    border: '2px solid var(--trashie-ui-faded-black-40)',
    '&:hover': {
      border: '2px solid var(--trashie-ui-faded-black-40)',
    },
  }),
  ...(variant === 'primary' && {
    borderRadius: '12px',
    border: 'none',
    '&:hover': {
      border: 'none',
    },
    ...(selected && {
      border: '2px solid var(--trashie-primary-code-blue)',
      '&:hover': {
        border: '2px solid var(--trashie-primary-code-blue)',
      },
    }),
  }),
  ...(disabled && {
    cursor: 'default',
    border: '2px solid var(--trashie-ui-crisp-white)',

    '&:hover': {
      border: '2px solid var(--trashie-ui-crisp-white)',
    },
  }),
  ...(error && {
    border: '2px solid var(--japan-color-dry-red)',
    '&:hover': {
      border: '2px solid var(--japan-color-dry-red)',
    },
  }),
}));

export default StyledCard;
